export default {
  path: '/office',
  component: () => import('@/layout/office/index.vue'),
  redirect: '/office/desktop',
  name: 'Office',
  meta: {
    title: '办公管理',
    icon: 'office-building',
    requiresAuth: true,
    moduleType: 'OFFICE'
  },
  children: [
    {
      path: 'desktop',
      name: 'OfficeDesktop',
      component: () => import('@/views/office/Desktop.vue'),
      meta: { 
        title: '工作台', 
        icon: 'desktop', 
        requiresAuth: true,
        moduleType: 'OFFICE'
      }
    },
    
    // 客户管理
    {
      path: 'customers',
      name: 'CustomerList',
      component: () => import('@/views/office/customers/index.vue'),
      meta: { title: '客户管理', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'customers/create',
      name: 'CustomerCreate',
      component: () => import('@/views/office/customers/create.vue'),
      meta: { title: '新增客户', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'customers/:id',
      name: 'CustomerDetail',
      component: () => import('@/views/office/customers/detail.vue'),
      meta: { title: '客户详情', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'customers/:id/edit',
      name: 'CustomerEdit',
      component: () => import('@/views/office/customers/edit.vue'),
      meta: { title: '编辑客户', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'customer-departments',
      name: 'CustomerDepartments',
      component: () => import('@/views/office/customer-departments/index.vue'),
      meta: { title: '客户部门管理', requiresAuth: true, moduleType: 'OFFICE' }
    },

    // 合同管理
    {
      path: 'contracts',
      name: 'ContractList',
      component: () => import('@/views/office/contracts/list.vue'),
      meta: { title: '合同管理', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'contracts/create',
      name: 'ContractCreate',
      component: () => import('@/views/office/contracts/create.vue'),
      meta: { title: '新建合同', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'contracts/:id',
      name: 'ContractDetail',
      component: () => import('@/views/office/contracts/detail.vue'),
      meta: { title: '合同详情', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'contracts/edit/:id',
      name: 'ContractEdit',
      component: () => import('@/views/office/contracts/edit.vue'),
      meta: { title: '编辑合同', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'contracts/statistics',
      name: 'ContractStatistics',
      component: () => import('@/views/office/contracts/statistics.vue'),
      meta: { title: '合同统计', requiresAuth: true, moduleType: 'OFFICE' }
    },

    // 旧仓库模块路由已废弃，整体移除

    {
      path: 'warehouse',
      name: 'WarehouseModuleRedirect',
      redirect: '/office/warehouse/dashboard',
      meta: { title: '仓库管理', icon: 'box', requiresAuth: true, moduleType: 'OFFICE' }
    },

    // 发货订单管理
    {
      path: 'shipping-orders',
      name: 'ShippingOrderList',
      component: () => import('@/views/office/shipping-orders/index.vue'),
      meta: { title: '发货订单管理', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'shipping-orders/create',
      name: 'ShippingOrderCreate',
      component: () => import('@/views/office/shipping-orders/create.vue'),
      meta: { title: '新建发货订单', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'shipping-orders/:id',
      name: 'ShippingOrderDetail',
      component: () => import('@/views/office/shipping-orders/detail.vue'),
      meta: { title: '发货订单详情', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'shipping-orders/:id/edit',
      name: 'ShippingOrderEdit',
      component: () => import('@/views/office/shipping-orders/edit.vue'),
      meta: { title: '编辑发货订单', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'shipping-orders/:id/confirm-receipt',
      name: 'ConfirmReceipt',
      component: () => import('@/views/office/shipping-orders/confirm-receipt.vue'),
      meta: { title: '确认收货', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'shipping-orders/statistics',
      name: 'ShippingOrderStatistics',
      component: () => import('@/views/office/shipping-orders/statistics.vue'),
      meta: { title: '发货统计', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'warehouse/item-create',
      name: 'ItemCreate',
      component: () => import('@/views/office/warehouse/item-create.vue'),
      meta: { title: '新建物品', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'warehouse/item-detail/:id',
      name: 'ItemDetail',
      component: () => import('@/views/office/warehouse/item-detail.vue'),
      meta: { title: '物品详情', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'warehouse/item-edit/:id',
      name: 'EditItem',
      component: () => import('@/views/office/warehouse/item-edit.vue'),
      meta: { title: '编辑物品', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'warehouse/detail/:id',
      name: 'WarehouseDetail',
      component: () => import('@/views/office/warehouse/detail.vue'),
      meta: { title: '仓库详情', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'warehouse/:id/edit',
      name: 'EditWarehouse',
      component: () => import('@/views/office/warehouse/edit.vue'),
      meta: { title: '编辑仓库', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'warehouse/:id/records',
      name: 'WarehouseRecords',
      component: () => import('@/views/office/warehouse/records.vue'),
      meta: { title: '仓库记录', requiresAuth: true, moduleType: 'OFFICE' }
    },

    // 采购单管理
    {
      path: 'warehouse/purchase-order-list',
      name: 'PurchaseOrderList',
      component: () => import('@/views/office/warehouse/purchase-order-list.vue'),
      meta: { title: '采购单管理', icon: 'shopping-cart', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'purchase-orders/statistics',
      name: 'PurchaseStatistics',
      component: () => import('@/views/office/purchase-orders/statistics.vue'),
      meta: { title: '采购统计', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'warehouse/purchase-order-create',
      name: 'PurchaseOrderCreate',
      component: () => import('@/views/office/warehouse/purchase-order-create.vue'),
      meta: { title: '新建采购单', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'warehouse/purchase-order-detail/:id',
      name: 'PurchaseOrderDetail',
      component: () => import('@/views/office/warehouse/purchase-order-detail.vue'),
      meta: { title: '采购单详情', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'warehouse/purchase-order-edit/:id',
      name: 'PurchaseOrderEdit',
      component: () => import('@/views/office/warehouse/purchase-order-edit.vue'),
      meta: { title: '编辑采购单', requiresAuth: true, moduleType: 'OFFICE' }
    },

    // 财务报表
    {
      path: 'reports/financial',
      name: 'FinancialReport',
      component: () => import('@/views/reports/financial/index.vue'),
      meta: { title: '财务报表', icon: 'chart-line', requiresAuth: true, moduleType: 'OFFICE' }
    },

    // 维修管理
    {
      path: 'repair',
      name: 'RepairManagement',
      redirect: '/office/repair/request',
      meta: { title: '维修管理', requiresAuth: true, moduleType: 'OFFICE' },
      children: [
        {
          path: 'request',
          name: 'RepairRequest',
          component: () => import('@/views/office/repair/request/list.vue'),
          meta: { title: '维修申请', requiresAuth: true, moduleType: 'OFFICE' }
        },
        {
          path: 'request/create',
          name: 'RepairRequestCreate',
          component: () => import('@/views/office/repair/request/create.vue'),
          meta: { title: '新建维修申请', requiresAuth: true, moduleType: 'OFFICE' }
        },
        {
          path: 'request/:id',
          name: 'RepairRequestDetail',
          component: () => import('@/views/office/repair/request/detail.vue'),
          meta: { title: '维修申请详情', requiresAuth: true, moduleType: 'OFFICE' }
        },
        {
          path: 'request/:id/edit',
          name: 'RepairRequestEdit',
          component: () => import('@/views/office/repair/request/edit.vue'),
          meta: { title: '编辑维修申请', requiresAuth: true, moduleType: 'OFFICE' }
        },
        {
          path: 'report',
          name: 'RepairReport',
          component: () => import('@/views/office/repair/report/index.vue'),
          meta: { title: '维修报告', requiresAuth: true, moduleType: 'OFFICE' }
        },
        {
          path: 'report/create',
          name: 'RepairReportCreate',
          component: () => import('@/views/office/repair/report/create.vue'),
          meta: { title: '新建维修报告', requiresAuth: true, moduleType: 'OFFICE' }
        },
        {
          path: 'report/:id',
          name: 'RepairReportDetail',
          component: () => import('@/views/office/repair/report/detail.vue'),
          meta: { title: '维修报告详情', requiresAuth: true, moduleType: 'OFFICE' }
        },
        {
          path: 'report/:id/edit',
          name: 'RepairReportEdit',
          component: () => import('@/views/office/repair/report/edit.vue'),
          meta: { title: '编辑维修报告', requiresAuth: true, moduleType: 'OFFICE' }
        }
      ]
    },
    // 采购申请单管理
    {
      path: 'purchase-requests',
      name: 'PurchaseRequestList',
      component: () => import('@/views/office/purchase-requests/index.vue'),
      meta: { title: '采购申请单管理', icon: 'Tickets', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'purchase-requests/create',
      name: 'PurchaseRequestCreate',
      component: () => import('@/views/office/purchase-requests/create.vue'),
      meta: { title: '新建采购申请单', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'purchase-requests/:id',
      name: 'PurchaseRequestDetail',
      component: () => import('@/views/office/purchase-requests/detail.vue'),
      meta: { title: '采购申请单详情', requiresAuth: true, moduleType: 'OFFICE' }
    },
    {
      path: 'purchase-requests/:id/edit',
      name: 'PurchaseRequestEdit',
      component: () => import('@/views/office/purchase-requests/edit.vue'),
      meta: { title: '编辑采购申请单', requiresAuth: true, moduleType: 'OFFICE' }
    },

    // 审批管理模块（保留三菜单）
    {
      path: 'approval',
      name: 'Approval',
      redirect: '/office/approval/my-applications',
      meta: {
        title: '审批管理',
        icon: 'check-circle',
        requiresAuth: true,
        moduleType: 'OFFICE'
      },
      children: [
        // 我的申请
        {
          path: 'my-applications',
          name: 'MyApplications',
          component: () => import('@/views/approval/desktop/My.vue'),
          meta: { 
            title: '我的申请', 
            requiresAuth: true,
            viewType: 'my',
            moduleType: 'OFFICE'
          }
        },

        // 待审批
        {
          path: 'pending',
          name: 'PendingApprovals',
          component: () => import('@/views/approval/desktop/Todo.vue'),
          meta: { 
            title: '待审批', 
            requiresAuth: true,
            viewType: 'pending',
            moduleType: 'OFFICE'
          }
        },

        // 审批历史
        {
          path: 'history',
          name: 'ApprovalHistory',
          component: () => import('@/views/approval/desktop/History.vue'),
          meta: { 
            title: '审批历史', 
            requiresAuth: true,
            viewType: 'history',
            moduleType: 'OFFICE'
          }
        },

        // 审批设置
        {
          path: 'settings',
          name: 'ApprovalSettings',
          component: () => import('@/views/approval/settings/ApproverSelection.vue'),
          meta: { 
            title: '审批设置', 
            requiresAuth: true,
            moduleType: 'OFFICE'
          }
        },

        // 测试页面
        {
          path: 'approver-test',
          name: 'ApprovalApproverTest',
          component: () => import('@/views/approval/ApproverTest.vue'),
          meta: { 
            title: '审批人选择测试', 
            icon: 'test-tube',
            requiresAuth: true,
            moduleType: 'OFFICE'
          }
        },
        {
          path: 'audit-logs',
          name: 'AuditLogs',
          component: () => import('@/views/audit/Logs.vue'),
          meta: {
            title: '审计日志',
            requiresAuth: true,
            icon: 'Document',
            permission: 'audit:view'
          }
        }
      ]
    }
  ]
}